<template>
  <div class="page">
    <PageHeader>
      Пользователи API обмена "Нам QIWI - мы USDT TRC20"
    </PageHeader>
    <div class="content">
      <el-card
        shadow="always"
        :body-style="{ padding: '20px' }"
        v-loading="loading"
      >
        <!-- <div slot="header">
        <span>Балансы</span>
      </div> -->
        <div v-if="apiUsers.docs">
          <el-table
            :data="apiUsers.docs"
            @sort-change="handleSortChange"
            :default-sort="{ prop: '_id', order: 'descending' }"
            :row-class-name="tableRowClassName"
            border
            stripe
          >
            <el-table-column sortable="custom" prop="_id" label="ID" width="90">
              <template slot-scope="scope">
                <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
                <router-link
                  :to="{ name: 'ApiUser', params: { id: scope.row._id } }"
                  >{{ scope.row._id.slice(-6) }}</router-link
                >
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="name"
              label="Имя"
              width="180"
            >
            </el-table-column>
            <el-table-column sortable="custom" prop="wallet" label="Кошелек">
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="fromMinLimit"
              label="Min FROM"
              width="150"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="fromMaxLimit"
              label="Max FROM"
              width="150"
            >
            </el-table-column>
            <!-- <el-table-column
              sortable="custom"
              prop="toMinLimit"
              label="Min TO"
              width="150"
              >
            </el-table-column>
            <el-table-column
            sortable="custom"
            prop="toMaxLimit"
            label="Max TO"
            width="150"
            >
          </el-table-column> -->
            <el-table-column
              sortable="custom"
              prop="fromPercentGive"
              label="FROM % покупки"
              width="150"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="toPercentGet"
              label="TO % продажи"
              width="150"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="ipWhitelist"
              label="IP"
              width="150"
            >
              <template slot-scope="scope">
                <div v-for="ip in scope.row.ipWhitelist" :key="ip">{{ ip }}</div>
              </template>
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="rateLimit"
              label="Лимит"
              width="100"
            >
            </el-table-column>
            <el-table-column
              sortable="custom"
              prop="isActive"
              label="Активен?"
              width="140"
            >
              <template slot-scope="scope">
                {{ scope.row.isActive ? "Да" : "Нет" }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="session.type <= -1"
              fixed="right"
              label="Действия"
              width="150"
            >
              <template slot-scope="scope">
                <el-tooltip placement="top">
                  <div slot="content">Удалить</div>
                  <el-button
                    size="small"
                    icon="el-icon-delete"
                    @click="handleDeleteItem(scope.row._id)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip placement="top">
                  <div slot="content">Редактировать</div>
                  <el-button
                    size="small"
                    icon="el-icon-edit"
                    @click="handleEditItem(scope.row._id)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="apiUsers.page"
            :page-size="apiUsers.limit"
            layout="prev, pager, next, jumper"
            :total="apiUsers.totalDocs"
          >
          </el-pagination>
        </div>
        <el-collapse v-model="activeCollapse">
          <el-collapse-item name="1">
            <template slot="title">
              <i class="header-icon el-icon-plus"></i>
              {{ isEditing ? "Изменить" : "Добавить" }}
            </template>
            <el-form
              :model="newApiUser"
              ref="form"
              label-width="280px"
              :inline="false"
              size="normal"
            >
              <el-form-item label="Имя">
                <el-input v-model="newApiUser.name"></el-input>
              </el-form-item>
              <el-form-item label="Кошелек USDT TRC20">
                <el-input v-model="newApiUser.wallet"></el-input>
              </el-form-item>
              <el-card shadow="always" :body-style="{ padding: '20px' }">
                <div slot="header">
                  <span
                    >QIWI - курс рассчетный = {{ fromRate }} | курс обменника =
                    {{ fromRateReference }} | курс биржи =
                    {{ fromRateExchange }}</span
                  >
                </div>
                <!-- {{ fromValuteReference }} -->
                <el-form-item label="Минимальная сумма на прием">
                  <el-input-number
                    v-model="newApiUser.fromMinLimit"
                    size="normal"
                    :min="0"
                    :step="1"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                  {{ fromValuteReference && fromValuteReference.minGive }}
                </el-form-item>
                <el-form-item label="Максимальная сумма на прием">
                  <el-input-number
                    v-model="newApiUser.fromMaxLimit"
                    size="normal"
                    :min="0"
                    :step="1"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item label="Процент покупки">
                  <el-input-number
                    v-model="newApiUser.fromPercentGive"
                    size="normal"
                    :min="0"
                    :step="0.001"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                  {{ fromValuteReference && fromValuteReference.percentGive }}
                </el-form-item>
                <!-- <el-form-item label="Процент продажи">
                  <el-input-number
                    v-model="newApiUser.fromPercentGet"
                    size="normal"
                    :min="0"
                    :step="0.001"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                  {{ fromValuteReference && fromValuteReference.percentGet }}
                </el-form-item> -->
              </el-card>

              <el-card shadow="always" :body-style="{ padding: '20px' }">
                <div slot="header">
                  <span
                    >USDT TRC20 - курс рассчетный = {{ toRate }} | курс обменника
                    = {{ toRateReference }} | курс биржи =
                    {{ toRateExchange }}</span
                  >
                </div>
                <!-- {{ toValuteReference }} -->
                <!-- <el-form-item label="Минимальная сумма на отдачу">
                  <el-input-number
                    v-model="newApiUser.toMinLimit"
                    size="normal"
                    :min="0"
                    :step="1"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                  {{ fromValuteReference && toValuteReference.minGive }}
                </el-form-item>
                <el-form-item label="Максимальная сумма на отдачу">
                  <el-input-number
                    v-model="newApiUser.toMaxLimit"
                    size="normal"
                    :min="0"
                    :step="1"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                </el-form-item> -->
                <!-- <el-form-item label="Процент покупки">
                  <el-input-number
                    v-model="newApiUser.toPercentGive"
                    size="normal"
                    :min="0"
                    :step="0.001"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                  {{ fromValuteReference && toValuteReference.percentGive }}
                </el-form-item> -->
                <el-form-item label="Процент продажи">
                  <el-input-number
                    v-model="newApiUser.toPercentGet"
                    size="normal"
                    :min="0"
                    :step="0.001"
                    :controls="true"
                    controls-position="both"
                  >
                  </el-input-number>
                  {{ fromValuteReference && toValuteReference.percentGet }}
                </el-form-item>
              </el-card>

              <el-form-item label="Разрешенные IP через запятую">
                <el-input v-model="newApiUser.ipWhitelist"></el-input>
              </el-form-item>
              <el-form-item label="Лимит запросов, штук в минуту">
                <el-input-number
                  v-model="newApiUser.rateLimit"
                  size="normal"
                  :min="0"
                  :max="60"
                  :step="1"
                  :controls="true"
                  controls-position="both"
                >
                </el-input-number>
              </el-form-item>
              <el-form-item label="Активен?">
                <el-switch
                  v-model="newApiUser.isActive"
                  :active-value="true"
                  :inactive-value="false"
                >
                </el-switch>
              </el-form-item>
              <el-form-item>
                <el-button v-if="isEditing" type="primary" @click="editItem"
                  >Сохранить</el-button
                >
                <el-button v-else type="primary" @click="addItem"
                  >Добавить</el-button
                >
                <el-button v-if="isEditing" @click="cancelEditItem"
                  >Отменить</el-button
                >
                <el-button v-else @click="resetForm">Очистить</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  </div>
</template>
<script>
import {
  getApiUsers,
  addApiUser,
  editApiUSer,
  deleteApiUser,
  getValutes
} from "@/api";
import { mapState, mapActions, mapGetters } from "vuex";
import PageHeader from "../../ui/PageHeader.vue";
const defaultApiUser = {
  name: "",
  wallet: "",
  fromMinLimit: 0,
  fromMaxLimit: 0,
  toMinLimit: 0,
  toMaxLimit: 0,
  fromPercentGive: 0,
  fromPercentGet: 0,
  toPercentGive: 0,
  toPercentGet: 0,
  ipWhitelist: "",
  rateLimit: 0,
  isActive: true
};
export default {
  components: { PageHeader },
  name: "ApiUsersPage",
  data: () => ({
    loading: true,
    newApiUser: {
      ...defaultApiUser
    },
    apiUsers: [],
    page: 1,
    limit: 10,
    sort: "-_id",
    valutes: [],
    activeCollapse: [],
    isEditing: false
  }),
  computed: {
    ...mapState("auth", ["session"]),
    fromValuteReference: function() {
      return this.valutes.find(v => v.bestchangeKey === "QWRUB");
    },
    toValuteReference: function() {
      return this.valutes.find(v => v.bestchangeKey === "USDTTRC");
    },
    fromRateExchange: function() {
      if (this.fromValuteReference && this.toValuteReference) {
        return this.fromValuteReference.course / this.toValuteReference.course;
      }
      return null;
    },
    toRateExchange: function() {
      if (this.fromRateExchange) {
        return 1 / this.fromRateExchange;
      }
      return null;
    },
    fromRateReference: function() {
      if (this.fromValuteReference && this.toValuteReference) {
        return (
          (this.fromValuteReference.course *
            this.fromValuteReference.percentGive) /
          (this.toValuteReference.course * this.toValuteReference.percentGet)
        );
      }
      return null;
    },
    toRateReference: function() {
      if (this.fromRateReference) {
        return 1 / this.fromRateReference;
      }
      return null;
    },
    fromRate: function() {
      if (this.fromValuteReference && this.toValuteReference) {
        return (
          (this.fromValuteReference.course *
            (this.newApiUser.fromPercentGive ||
              this.fromValuteReference.percentGive)) /
          (this.toValuteReference.course *
            (this.newApiUser.toPercentGet || this.toValuteReference.percentGet))
        );
      }
      return null;
    },
    toRate: function() {
      if (this.fromRate) {
        return 1 / this.fromRate;
      }
      return null;
    }
  },
  methods: {
    async getApiUsers() {
      try {
        this.loading = true;
        const { data } = await getApiUsers({
          page: this.page,
          limit: this.limit,
          sort: this.sort
        });
        if (data.status) this.apiUsers = data.result;
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleDeleteItem(id) {
      let message = "Вы точно хотите удалить пользователя API?";
      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await deleteApiUser(id);
        await this.getApiUsers();
        this.$message({
          type: "success",
          message: `Пользователь API успешно удален`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    handleEditItem(id) {
      this.activeCollapse = ["1"];
      this.isEditing = true;
      this.newApiUser = { ...this.apiUsers.docs.find(u => u._id === id) };
    },
    async handleSortChange(sortData) {
      this.sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.getApiUsers();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getApiUsers();
    },
    resetForm() {
      this.newApiUser = {
        ...defaultApiUser
      };
    },
    async addItem() {
      try {
        const data = {
          ...this.newApiUser,
          ipWhitelist: this.newApiUser.ipWhitelist
            .split(",")
            .map(item => item.trim())
            .filter(item => !!item)
        };
        const resp = await addApiUser(data);
        await this.getApiUsers();
        this.resetForm();
        return this.$notify.success({
          title: "Успех",
          message: `Пользователь API ${resp.data.result.name || ""} создан!`
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    },
    async editItem() {
      try {
        const data = {
          ...this.newApiUser,
          ipWhitelist: Array.isArray(this.newApiUser.ipWhitelist)
            ? this.newApiUser.ipWhitelist
            : this.newApiUser.ipWhitelist
                .split(",")
                .map(item => item.trim())
                .filter(item => !!item)
        };
        const resp = await editApiUSer(this.newApiUser._id, data);
        this.isEditing = false;
        this.activeCollapse = [];
        await this.getApiUsers();
        this.resetForm();
        return this.$notify.success({
          title: "Успех",
          message: `Пользователь API ${resp.data.result.name || ""} изменен!`
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    },
    cancelEditItem() {
      this.isEditing = false;
      this.activeCollapse = [];
      this.resetForm();
    }
  },
  async mounted() {
    this.loading = true;
    await this.getApiUsers();
    const resp = await getValutes();
    if (resp.data.status) this.valutes = resp.data.result;
    this.loading = false;
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/ApiUsers/index.vue